import React from 'react'
import Badge from '../ui/Badge'
import Button from '../ui/Button'
import { Card } from '../ui/Card'

const typeIcon = { practice: '📝', game: '🎮', blockly: '🧩' }
const difficultyTone = { easy: 'success', medium: 'warning', hard: 'danger' }

export default function ActivityCard({ activity, onStart }) {
  return (
    <Card className="activity-card">
      <div className="card-topline">
        <span className="activity-icon">{typeIcon[activity.type] || '📚'}</span>
        <Badge tone={difficultyTone[activity.difficulty] || 'default'}>{activity.difficulty}</Badge>
      </div>
      <h3>{activity.title}</h3>
      <p>{activity.description}</p>
      <div className="tag-cloud">
        {(activity.learningDimensions || []).map((item) => <Badge key={item} tone="info">{item}</Badge>)}
        {(activity.supportNeeds || []).map((item) => <Badge key={item} tone="success">{item}</Badge>)}
      </div>
      {activity.objective ? <p><strong>Objetivo:</strong> {activity.objective}</p> : null}
      {activity.guidance ? <p><strong>Mediação:</strong> {activity.guidance}</p> : null}
      {(activity.resources || []).length ? <p><strong>Recursos:</strong> {activity.resources.join(' • ')}</p> : null}
      {(activity.adaptations || []).length ? (
        <ul className="list-soft">
          {activity.adaptations.slice(0, 3).map((item) => <li key={item}>{item}</li>)}
        </ul>
      ) : null}
      <div className="meta-row">
        <span>⏱️ {activity.durationMinutes} min</span>
        <span>📊 Série {activity.grade}</span>
      </div>
      <div className="button-wrap">
        <Button className="flex-1" onClick={() => onStart(activity)}>Iniciar</Button>
        {activity.accessLevel !== 'free' ? <Badge tone="warning">Premium</Badge> : null}
      </div>
    </Card>
  )
}
